import {PAGE_LOADED, PAGE_LOADING} from '../actions/page'
import Vue from "vue";

const state = {
    loading: false, modal: {
        show: false, message: null, onOpen: () => {
        }, onClose: () => {
        }
    }
};

const getters = {
    getModal: state => state.modal,
};

const actions = {
    [PAGE_LOADING]: ({commit}) => {
        commit(PAGE_LOADING);
    },
    [PAGE_LOADED]: ({commit}) => {
        commit(PAGE_LOADED);
    },
};

const mutations = {
    [PAGE_LOADING]: (state) => {
        $('body').addClass("cargando");
        state.loading = true;
    },
    [PAGE_LOADED]: (state) => {
        $('body').removeClass("cargando");
        state.loading = false;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/page.js